import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostCreateJackpot = (params, setOpenModalSuccess, setOpenModalError) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_CREATE_JACKPOT
            });
            setOpenModalSuccess(true);
        } catch (error) {
            //todo доделать catch 
            setOpenModalError(true)
            getCatchError(error)
        }
    }
}

export {
    setPostCreateJackpot as SetPostCreateJackpot
}